/*
 * @Description: 楼栋控制器
 */

import { ReportControllerFac } from './_utils'

const BASE_URL = `/api/organization/orderDetail/building`
const ApiController = new ReportControllerFac(BASE_URL)

export default ApiController
